import React from 'react';
import type { WrapPageElementBrowserArgs, WrapPageElementNodeArgs } from 'gatsby';

import { I18nProvider } from './I18nContext';
import { LocaleHead } from './LocaleHead';
import { DEFAULT_LOCALE, isLocale } from './locales';

export function wrapPageElement({
  element,
  props,
}: WrapPageElementBrowserArgs | WrapPageElementNodeArgs) {
  const locale = isLocale(props.pageContext.locale) ? props.pageContext.locale : DEFAULT_LOCALE;

  return (
    <I18nProvider locale={locale} pathname={props.location.pathname}>
      <LocaleHead pathname={props.location.pathname} />
      {element}
    </I18nProvider>
  );
}
